import { render, staticRenderFns } from "./MenuLateralSalaAula.vue?vue&type=template&id=37a8a8a7&scoped=true"
import script from "./MenuLateralSalaAula.vue?vue&type=script&lang=js"
export * from "./MenuLateralSalaAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8a8a7",
  null
  
)

export default component.exports